module.exports = __webpack_public_path__ + "static/media/BP.19576a73.png";